<template>
  <div class="spush-select">
    <div class="spush-select__selected" @click="toggleDropdown">
      <div class="spush-select__selected-text">{{ currentLocale }}</div>
      <div
        :class="{ 'spush-select__selected-icon--open': isOpen }"
        class="spush-select__selected-icon">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="25"
          viewBox="0 0 24 25"
          fill="none">
          <g clip-path="url(#clip0_1_24)">
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M15.535 10.5506C15.3474 10.3632 15.0931 10.2579 14.828 10.2579C14.5628 10.2579 14.3085 10.3632 14.121 10.5506L12 12.6716L9.87897 10.5506C9.69146 10.363 9.4371 10.2575 9.17183 10.2574C8.90656 10.2574 8.65211 10.3626 8.46447 10.5501C8.27683 10.7377 8.17136 10.992 8.17127 11.2573C8.17118 11.5226 8.27646 11.777 8.46397 11.9646L11.293 14.7936C11.4805 14.9811 11.7348 15.0864 12 15.0864C12.2651 15.0864 12.5194 14.9811 12.707 14.7936L15.535 11.9646C15.7224 11.7771 15.8278 11.5228 15.8278 11.2576C15.8278 10.9925 15.7224 10.7382 15.535 10.5506Z"
              fill="var(--spush-main-color)" />
          </g>
          <defs>
            <clipPath id="clip0_1_24">
              <rect width="24" height="24" fill="white" transform="translate(0 0.25769)" />
            </clipPath>
          </defs>
        </svg>
      </div>
    </div>

    <ul v-if="isOpen" class="spush-select__dropdown">
      <li
        v-for="(locale, index) in options"
        :key="index"
        class="spush-select__option"
        @click="handleSelect(locale)">
        {{ locale }}
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  mounted() {
    document.addEventListener('click', this.handleClickOutside);
  },
  beforeDestroy() {
    document.removeEventListener('click', this.handleClickOutside);
  },
  data() {
    return {
      locales: ['en', 'de', 'es', 'pt', 'tr', 'fr', 'it'],
      isOpen: false,
    };
  },
  computed: {
    currentLocale() {
      return this.$i18n.locale || 'en';
    },

    options() {
      return this.locales.filter(el => el !== this.currentLocale);
    },
  },
  methods: {
    toggleDropdown() {
      this.isOpen = !this.isOpen;
    },

    handleSelect(locale) {
      this.$i18n.locale = locale;
      this.isOpen = false;
    },

    handleClickOutside(event) {
      if (!this.$el.contains(event.target)) {
        this.isOpen = false;
      }
    },
  },
};
</script>

<style lang="scss">
.spush-select {
  position: relative;

  &__selected {
    display: flex;
    align-items: center;
    cursor: pointer;

    &-text {
      text-transform: capitalize;
      font-size: 18px;
      font-style: normal;
      font-weight: 400;
      line-height: normal;
      color: var(--spush-main-color);
      height: 18px;
      margin-right: 3px;
    }

    &-icon {
      height: 24px;
      transition: 0.3s;

      &--open {
        transform: rotate(180deg);
      }
    }
  }

  &__dropdown {
    position: absolute;
    left: -30px;
    top: 32px;
    width: 90px;
    padding: 8px 0;
    box-shadow: 0px 15px 26px 0px var(--spush-form-shadow-color);
    border-radius: 8px;
    background: var(--spush-form-color);
  }

  &__option {
    padding: 8px 20px;
    font-size: 18px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    color: var(--spush-main-color);
    text-transform: capitalize;
    cursor: pointer;

    &:hover,
    &:focus {
      color: var(--spush-second-color);
    }

    @media (hover: none) {
      &:hover {
        color: var(--spush-main-color);
      }
    }
  }
}
</style>
